module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("hmXB4"))).then(() => parcelRequire('hEqeo'));